import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { useQuery } from 'react-query';
import { useAlert } from 'shared/components/alerts';
import { Site } from 'shared/hooks';

export const MIN_PREFERRED_WORKER_SEARCH_LENGTH = 3;

export const useGetPreferredWorkerOptions = ({
  site,
  companyId,
  departmentId,
  jobTypeId,
  startDate,
  startTime,
  endDate,
  endTime,
  isTempWork,
  isFreelance,
  isEmployee,
  flexPoolIds,
  flexPoolOnly,
  certificates,
  nameSearch,
}: {
  site: Site;
  companyId?: string;
  departmentId?: string;
  jobTypeId?: string;
  startDate?: string;
  startTime?: string;
  endDate?: string;
  endTime?: string;
  isTempWork?: boolean;
  isFreelance?: boolean;
  isEmployee?: boolean;
  flexPoolIds?: string[];
  flexPoolOnly?: boolean;
  certificates?: string[];
  nameSearch?: string;
}) => {
  const { alertError } = useAlert();
  const hasEnoughSearchInput =
    (nameSearch?.trim().length ?? 0) >= MIN_PREFERRED_WORKER_SEARCH_LENGTH;
  const enabled =
    !!site &&
    !!departmentId &&
    !!jobTypeId &&
    !!startDate &&
    !!endDate &&
    !!startTime &&
    !!endTime &&
    !!(isTempWork || isFreelance || isEmployee) &&
    hasEnoughSearchInput;

  const startDateTime = `${startDate}T${startTime}`;
  const endDateTime = `${endDate}T${endTime}`;

  return useQuery(
    QUERY_KEYS.preferredWorkerOptions(
      companyId,
      departmentId,
      jobTypeId,
      certificates,
      isTempWork,
      isFreelance,
      isEmployee,
      flexPoolIds,
      flexPoolOnly,
      startDateTime,
      endDateTime,
      nameSearch
    ),
    async () =>
      await sharedShiftService.getPreferredWorkerOptions(
        site,
        companyId,
        departmentId,
        jobTypeId,
        certificates,
        isTempWork,
        isFreelance,
        startDateTime,
        endDateTime,
        isEmployee,
        flexPoolIds,
        flexPoolOnly,
        nameSearch
      ),
    { enabled, onError: (e) => alertError(e) }
  );
};
